// Service d'authentification simplifié et fiable

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const USER_KEY = 'user_data';

class SimpleAuthService {
  // Stocker les tokens
  setTokens(accessToken: string, refreshToken: string, userData: any): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
    console.log('✅ Tokens stockés');
  }

  // Récupérer l'access token
  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  // Récupérer le refresh token
  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  // Récupérer les données utilisateur
  getUserData(): any | null {
    const data = localStorage.getItem(USER_KEY);
    if (!data) return null;
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }

  // Vérifier si l'utilisateur est authentifié
  isAuthenticated(): boolean {
    const token = this.getAccessToken();
    if (!token) return false;
    
    // Vérifier si le token n'est pas expiré
    try {
      const payload = this.decodeToken(token);
      if (!payload || !payload.exp) return false;
      
      const now = Math.floor(Date.now() / 1000);
      return payload.exp > now;
    } catch {
      return false;
    }
  }

  // Décoder un JWT (sans vérification de signature)
  private decodeToken(token: string): any {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) return null;
      
      const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const decoded = atob(payload);
      return JSON.parse(decoded);
    } catch {
      return null;
    }
  }

  // Rafraîchir le token
  async refreshToken(): Promise<boolean> {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      console.log('❌ Pas de refresh token');
      return false;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/auth/token/refresh/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh: refreshToken })
      });

      if (!response.ok) {
        console.log('❌ Refresh échoué:', response.status);
        this.clearTokens();
        return false;
      }

      const data = await response.json();
      if (!data.access) {
        console.log('❌ Pas de nouveau token dans la réponse');
        this.clearTokens();
        return false;
      }

      // Mettre à jour uniquement l'access token
      localStorage.setItem(ACCESS_TOKEN_KEY, data.access);
      console.log('✅ Token rafraîchi');
      return true;
    } catch (error) {
      console.error('❌ Erreur refresh:', error);
      this.clearTokens();
      return false;
    }
  }

  // Effacer tous les tokens
  clearTokens(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    console.log('🗑️ Tokens effacés');
  }

  // Déconnexion
  logout(): void {
    this.clearTokens();
    window.dispatchEvent(new Event('auth:logout'));
  }
}

export const authService = new SimpleAuthService();
export default authService;
